import { Controller } from "@hotwired/stimulus"

/**
 * Highlights {{ variable }} markers in a textarea using an overlay technique.
 *
 * Usage:
 *   <div data-controller="highlight-textarea">
 *     <div data-highlight-textarea-target="backdrop" class="highlight-backdrop"></div>
 *     <textarea data-highlight-textarea-target="textarea" data-action="input->highlight-textarea#update scroll->highlight-textarea#sync"></textarea>
 *   </div>
 */
export default class extends Controller {
  static targets = ["textarea", "backdrop"]

  connect() {
    this.update()
  }

  update() {
    const text = this.textareaTarget.value
    // Escape HTML, then highlight {{ ... }} markers
    const highlighted = this.escapeHtml(text)
      .replace(/(\{\{[^}]*\}\})/g, '<mark class="highlight-variable">$1</mark>')

    // Add a trailing newline so the backdrop height matches textarea
    this.backdropTarget.innerHTML = highlighted + "\n"
  }

  sync() {
    this.backdropTarget.scrollTop = this.textareaTarget.scrollTop
    this.backdropTarget.scrollLeft = this.textareaTarget.scrollLeft
  }

  escapeHtml(text) {
    return text
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
  }
}
